// Status för en beställning av fakturautskick (snd_order.status). Speglar backend-enumen SendingOrderStatus.
export enum SendingOrderStatusEnum {
  Pagaende = 0, // Pågående – kunden fyller fortfarande i beställningen
  Inskickad = 1, // Inskickad – kunden har skickat in beställningen till FS
  KompletteringBehovs = 2, // Komplettering behövs – FS har skickat tillbaka för komplettering
  Levererad = 3, // Levererad – beställningen är hanterad/utskickad
}

// Färg-token som delade CustomChip förstår (samma design som statuschipsen i medlemsregistret).
export type SendingOrderStatusColor = 'success' | 'warning' | 'error' | 'info' | 'grey';

export interface SendingOrderStatusMeta {
  label: string;
  color: SendingOrderStatusColor;
}

// Färger enligt beställning: Pågående = ljusblå (info), Inskickad = gul (warning), Komplettering behövs = röd (error), Levererad = grön (success).
export const SENDING_ORDER_STATUS_META: Record<number, SendingOrderStatusMeta> = {
  [SendingOrderStatusEnum.Pagaende]: { label: 'Utkast', color: 'info' },
  [SendingOrderStatusEnum.Inskickad]: { label: 'Inskickad', color: 'warning' },
  [SendingOrderStatusEnum.KompletteringBehovs]: { label: 'Komplettering behövs', color: 'error' },
  [SendingOrderStatusEnum.Levererad]: { label: 'Levererad', color: 'success' },
};

export const getSendingOrderStatusMeta = (status: number | undefined | null): SendingOrderStatusMeta =>
  SENDING_ORDER_STATUS_META[status ?? SendingOrderStatusEnum.Pagaende] ?? SENDING_ORDER_STATUS_META[SendingOrderStatusEnum.Pagaende];
